import React, { useState, useEffect } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { FaExclamationTriangle, FaSpinner } from "react-icons/fa";
import Modal from "../../components/UI/Modal/Modal";
import DeviceIcon from "../../components/UI/DeviceIcon/DeviceIcon"
import Spinner from "../../components/UI/Spinner/Spinner";
import classes from "./MultiRouterAccount.css";
import axios from '../../axios-local-api';

const RouterCard = (props) => {
  const { router = {}, modem, accountNumber, ind, onUnClaimedPods, unclaimedPodSuccess, unClaimedPodFailure, isunClaimedPodRequestLoading } = props;
  // console.log(">>>={}", router, ind)
  const [isExpanded, setExpanded] = useState(false);
  const [isUnassignPodModalOpen, setIsUnassignPodModalOpen] = useState(false);
  const [currentPodSerialNumber, setCurrentPodSerialNumber] = useState("");
  const connectedStatus = router?.connectionState || 'N/A';
  const arrow = isExpanded ? (
    <MdKeyboardArrowUp size={"30px"} />
  ) : (
    <MdKeyboardArrowDown size={"30px"} />
  );
  const closePodModal = () => {
    setIsUnassignPodModalOpen(false)
    setIsUnassignPodModalOpen(false);
    setCurrentPodSerialNumber("");
  }
  let esso = sessionStorage.getItem("esso");
  let tm = sessionStorage.getItem('techMobile');
  let winServerUrl = sessionStorage.getItem("winServerUrl");

  if (isUnassignPodModalOpen && (unclaimedPodSuccess || unClaimedPodFailure)) {
    closePodModal()
  }
  const unclaimPodHandler = (serialNumber) => {
    togglePodModal();
    setCurrentPodSerialNumber(serialNumber)
  }

  const togglePodModal = () => {
    setIsUnassignPodModalOpen(!isUnassignPodModalOpen)
  }

  // const UnassignedPods  = (serialNumber) => {
  //    dispatch(actions.unassignedPod(serialNumber));
  //  }
  const routerDetails = (
    <div className={classes.box}>
      <div>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
          <DeviceIcon
            originalDevice={{
              deviceIconReference: "ROUTERICON"
            }}
            size={40}
          />
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
            <span style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'left' }}>Router</span>
            <div id = 'ABWRoutModel' className={[classes.field, { textAlign: 'left' }, { fontSize: '12px' }]}>{router.model}</div>
            <span id ='ABWRouterConnectedDevices' style={{ fontSize: 12, textAlign: 'left' }}>Connected Device: {router.connectedDeviceCount}</span>
          </div>
        </div>


      </div>
      <div style={{ marginLeft: 20 }}>
        {router.pods && router.pods?.map((pod) => (
          <div className={classes.routerHeading}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <DeviceIcon
                originalDevice={{
                  deviceIconReference: "BACKHAULICON"
                }}
                size={30}
              />
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.25rem', flexDirection: 'column' }}>
                <span style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'left' }}>Extender</span>
                <span id = 'ABWPodModel' style={{ fontSize: 12, textAlign: 'left' }}>{pod.podName}</span>
                <span id ='ABWPodConnectedDevices' style={{ fontSize: 12, textAlign: 'left' }}>Connected Device: {pod.connectedDeviceCount}</span>
              </div>

            </div>

            <button id='PodUnclaim' className={classes.podUncliam} onClick={() => unclaimPodHandler(pod.serialNumber)}>Unclaim</button>
          </div>
        ))}
      </div>
    </div>
  );

  let ipv6 = 'N/A';
if(router?.ipv6?.length){
  ipv6 = router?.ipv6.join(' ');
  ipv6 = ipv6.length > 16 ? ipv6.substring(0, 16) + '...' : ipv6;
}

  return (
    <div className={classes.boxWrapper}>
      <Modal show={isUnassignPodModalOpen} modalClosed={closePodModal} fullWidth='true'>
        <div className={classes.unassignPodModal}>
          <FaExclamationTriangle id='ABWUnassignWarning' fontSize="2rem" color="#e5b91d" />
          <span id='ABWUnassignTxt' >
            Unassigning this Extender will temporarily disrupt connected devices. Do you want to proceed?
          </span>
          {!isunClaimedPodRequestLoading && <div className={classes.ButtonRow}>
            <button
              id='ABWProceedButton'
              visibility='true'
              className={classes.CancelButton}
              onClick={closePodModal}
            >
              {'Cancel'}
            </button>
            <button
              id='ABWCancelButton'

              onClick={() => onUnClaimedPods(currentPodSerialNumber, router?.oneSsid)}
              className={classes.Button}
            >
              {'Proceed'}
            </button>

          </div>}

          {isunClaimedPodRequestLoading && <Spinner />}
        </div>
      </Modal >
    
      
      <div className={classes.box}>
        <div className={classes.routerHeading}>
          <h1 id='ABWSSIDName' className={classes.routerName}>{router?.oneSsid || 'SSID NAME'}</h1>
          <div className={classes.viewRouter} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <a id={`autoid${ind}`} style={{ color: '#fff', fontSize: 14, textDecoration: 'none' }} href={`${window.location.href}/?HOSTED=${sessionStorage.getItem('hosted')}&CUSTID=${sessionStorage.getItem('accountNumber')}&ESSO=${sessionStorage.getItem('esso')}&DIVID=${sessionStorage.getItem('divID')}&DWELL=null&USERID=${sessionStorage.getItem('userId')}&sessionToken=${sessionStorage.getItem('sessionToken')}&WINSERVERURL=${sessionStorage.getItem('winServerUrl')}&TM=${sessionStorage.getItem('techMobile')}&GROUPENABLED=${sessionStorage.getItem('groupEnabled')}&ADIDENABLED=${sessionStorage.getItem('adidEnabled')}&HANDLETOPOLOGY=${sessionStorage.getItem('handleTopology')}&MULTI=true&MULTIMAC=${router.mac}&TYPE=${sessionStorage.getItem('type')}&FEATUREFLAGS=${sessionStorage.getItem('featureFlags')}&UR=${sessionStorage.getItem('ur')}&USERROLES=${sessionStorage.getItem('userRoles')}`} target="_blank">View Router</a>

            {/* {!sessionStorage.getItem('type').includes('Business') && <a id={`autoid${ind}`} style={{ color: '#fff', fontSize: 14, textDecoration: 'none' }} href={`${tm === 'true' || tm === true ? winServerUrl + "techmobile/sso?CUSTID=" : esso}${accountNumber}!${router.mac}`} target="_blank">View Router</a>} */}
            {/* {sessionStorage.getItem('type').includes('Business') && <a id={`autoid${ind}`} style={{ color: '#fff', fontSize: 14, textDecoration: 'none' }} href={`${tm === 'true' || tm === true ? winServerUrl + "techmobile/sso?CUSTID=" : esso}${accountNumber}!${router.mac}!${'b'}`} target="_blank">View Router</a>} */}
            {/* <a id="autoid" style={{color:'#fff', fontSize:14, textDecoration:'none'}} href={`${tm?winServerUrl:esso}/saml-sp/sso?CUSTID=${accountNumber}!${"94917f230369"}`} target="_blank">View Router</a> */}
          </div>

        </div>
        <div className={classes.field} id='ABWRouterStatus' style={{ display: 'flex', alignItems: 'center', textTransform: "capitalize" }}>Status: &nbsp;  <span id='ABWRouterStatusTxt' className={classes[connectedStatus]}></span> {connectedStatus} </div>
        <div className={classes.field} id='ABWRouterSecondSSID'>Guest WiFi: &nbsp; {router?.additionalNetworks?.[0] == null ? 'N/A' : (router.additionalNetworks[0].enable ? 'ON' : 'OFF')}</div>
        <div className={classes.field} id='ABWRouterModel' >Model: &nbsp; {router.model}</div>
        <div className={classes.field} id='ABWRouterMac'>MAC:  &nbsp; {router.mac}</div>
        <div className={classes.field} id='ABWRouterIPV6'>IPV6: &nbsp;  <span title={router?.ipv6?.join(' ') || 'N/A'} style={{ whiteSpace: 'pre-line', wordBreak: 'break-all' }}>{ipv6}</span></div>
        <div className={classes.field} id='ABWRouterIPV4'>IPV4:  &nbsp; {router.ipv4 || 'N/A'}</div>
        <div className={classes.field} id='ABWRouterSerial'>Serial: &nbsp; {router.serialNumber || 'N/A'}</div>
        <div className={classes.field} style={{ color: 'gray' }} id='ABWRouterModem'>Modem: &nbsp; {modem?.typeDescription || 'N/A'}</div>
        <div className={classes.field} style={{ color: 'gray' }} id='ABWRouterModemMac'>Modem Mac: &nbsp; {modem?.mac || 'N/A'}</div>
      </div>

      {isExpanded && routerDetails}

      <div>
        <button
          id='viewRouterDetails'
          className={classes.viewDetails}
          onClick={() => {
            setExpanded((val) => !val);
          }}
        >
          {isExpanded ? "Hide Details" : "View Details"}
          {arrow}
        </button>
      </div>
    </div>
  );
};

export default RouterCard;
